import React, { useContext } from 'react';

import CartContext from '../../store/cart-context';
import classes from './CartButton.module.css';

const CartButton = ({ onClick }) => {
  const cartContext = useContext(CartContext);

  const itemsAmount = cartContext.items.reduce((curr, item) => {
    return curr + (item.products.length);
  }, 0);

  return (
    <button className={`${classes.button} ms-auto`} onClick={onClick}>
      <span className={classes.icon}>
        <i className='fas fa-shopping-cart'></i>
      </span>
      <span className={classes.badge}>{itemsAmount}</span>
    </button>
  );
};

export default CartButton;
